import {inject, injectable} from 'inversify';

import type {ApiListResponse} from '../../../../../api/types';
import type {CoreUserCategoriesListParams} from '../../../../../api/types/core/methods';
import type {FetchCategoriesQuery} from '../FetchCategories.query';

import {apiRequest} from '../../../../../api/utils/apiRequest';
import {CategoryMapperJrpc} from '../../../../domain/Category/mappers/Category.mapper.jrpc';

@injectable()
export class FetchCategoriesQueryJrpc implements FetchCategoriesQuery {
  constructor(
    @inject(CategoryMapperJrpc)
    private readonly mapper: CategoryMapperJrpc,
  ) {}

  async fetch(
    params?: FetchCategoriesQuery.Params,
  ): Promise<FetchCategoriesQuery.Response> {
    const type = params?.type || 'article';

    const {_items}: ApiListResponse<CategoryMapperJrpc.ApiData> =
      await apiRequest<CoreUserCategoriesListParams>({
        method: 'user.categories.list',
        params: {
          limit: 999,
          query: [['type', '==', type]],
          sort: [['weight', -1]],
        },
      });

    return _items.map(category => this.mapper.mapDataToModel(category));
  }
}
